// extracted by mini-css-extract-plugin
export default {"alertContainer":"styles_alert-container_Ex_CG","alert":"styles_alert_gFRGf"};